module.exports = __webpack_public_path__ + "static/icons/icon-snow-alert--red-03a3489c621490ad04a037431f8c2f35.svg";